$(document).ready(function() {
    // Function to set the checkbox state and store it in localStorage
    function setCheckboxState(state) {
        $(".toggle input:checkbox").prop("checked", state);
        if (state) {
            $('.template-collection .shopify-section--main-collection').addClass("showmodel");
            console.log('Showmodel');
        } else {
            $('.template-collection .shopify-section--main-collection').removeClass("showmodel");
            console.log('Don\'t showmodel');
        }
        localStorage.setItem('checkboxState', state);
    }

    // Check if the checkbox was previously checked and set its state on initial load
    var storedCheckboxState = localStorage.getItem('checkboxState');
    if (storedCheckboxState === 'true') {
        setCheckboxState(true);
    } else if (storedCheckboxState === 'false') {
        setCheckboxState(false);
    }

    // Use event delegation to handle changes on checkboxes within a container
    $(document).on('change', '.toggle input:checkbox', function(){
        if ($(this).is(":checked")) {
            $('.template-collection .shopify-section--main-collection').addClass("showmodel");
            console.log('Showmodel');
        } else {
            $('.template-collection .shopify-section--main-collection').removeClass("showmodel");
            console.log('Don\'t showmodel');
        }

        // Store the checkbox state in localStorage
        localStorage.setItem('checkboxState', $(this).is(":checked"));
    });

    // Add a custom event listener to handle checkbox state after pagination
    $(document).on("facet:update", function(event) {
        // Add a 500ms delay before checking and setting the checkbox state
        setTimeout(function() {
            // Check if the checkbox should be checked based on the stored state
            if (localStorage.getItem('checkboxState') === 'true') {
                setCheckboxState(true);
            } else {
                setCheckboxState(false);
            }
        }, 500); // Adjusted to 500ms delay
    });
});


/*
document.addEventListener('facet:update', function() {
    console.log('facet')
});
*/


